import React from 'react';
import { Toast } from '@syneto/compass-react';
import { connect } from 'react-redux';
import { removeNotification } from '../data/notifications/actions';

const AUTOHIDE_DELAY_MS = 9000;

/**
 * A store entry should always be a string, but a bad call site can still forward an
 * error object. Coerce it to something renderable so a React child never blows up
 * the whole app (see SYN-2637) even if that ever happens again.
 */
const toDisplayText = (text) => {
	if (typeof text === 'string') {
		return text;
	}

	if (text === null || text === undefined) {
		return '';
	}

	if (text instanceof Error && typeof text.message === 'string') {
		return text.message;
	}

	if (typeof text === 'object') {
		try {
			return JSON.stringify(text);
		} catch (e) {
			return 'An error occurred';
		}
	}

	return String(text);
};

const Notification = (props) => {
	return (
		<div style={ {
			position: 'fixed',
			bottom:   20,
			right:    0,
			margin:   30,
			width:    350,
			height:   'auto',
			zIndex:   99999
		} }>
			{ props.notifications.map((notification) => {
				const item = notification[ notification.key ];
				const text = toDisplayText(item.text);
				const isMultiline = text.indexOf('\n') !== -1;

				return (
					text !== '' ?
						<Toast
							color={ item.type }
							show={ true }
							onClose={ () => { props.dispatch(removeNotification(notification.key)); } }
							delay={ AUTOHIDE_DELAY_MS }
							autohide={ !isMultiline }
							key={ notification.key }
						>
							<Toast.Header
								style={ {
									display:        'flex',
									justifyContent: 'space-between'
								} }
							>
								{ item.type === 'danger' ? 'Error' : item.type.toUpperCase() }
							</Toast.Header>
							<Toast.Body style={ { whiteSpace: 'pre-line' } }>{ text }</Toast.Body>
						</Toast> : ''
				);
			}) }
		</div>
	);
};

const mapStateToProps = ((state) => {
	return {
		notifications: state.notifications
	};
});

export default connect(mapStateToProps)(Notification);
